/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/


import React from 'react'
import { MessageText } from '../../constants/messageText'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './signUpSucees.scss'
import { Button } from '@mui/material';
import { docSearchBasePath } from '../../constants/env-url';
import { useNavigate } from "react-router-dom";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

interface Prop {
    showMobileText: any,
    closeConfirmation: any,
    showText: any,
    popupName: any,
    popupDevice: any,
}

export const SignUpSucees: React.FC<any> = (prop: Prop) => {
    const navigate = useNavigate();

    return (
        <div className='msgWrapper'>
            <div className='msgTxt'>
                <div className='iconWrapper'>
                    <CheckCircleOutlineIcon sx={{ color: '#68B93A', fontSize: 50 }} />
                </div>
                <div className='msg_title'>
                    <span>{MessageText.SIGNUP_MSG_TITLE}</span>
                </div>
                <div className='msg_desc'>
                    <span>
                        {prop.showText}
                    </span>
                    {prop.popupDevice && <span className='msg_desktop'>{prop.showMobileText}</span>}
                </div>
                {prop.popupName === 'guestUserSignUp' && !prop.popupDevice &&
                    <div className='timeCount'>
                        <CountdownCircleTimer
                            isPlaying
                            duration={10}
                            size={100}
                            colors={['#0288c3', '#afd170']}
                            colorsTime={[5, 0]}
                            onComplete={() => {
                                window.open(docSearchBasePath, '_self');
                            }}
                        >
                            {({ remainingTime }) => remainingTime}
                        </CountdownCircleTimer>
                    </div>
                }
                <div className="btnWrapper">
                    {prop.popupName !== "signUpTrialDesktop" &&
                        <Button
                            type="submit"
                            fullWidth
                            size="medium"
                            variant="contained"
                            className="signupBtn"
                            onClick={() => {
                                if (prop.popupName === 'signUp' || prop.popupName === 'desktop_second_time') {
                                    navigate("/login");
                                } else {
                                    window.open(docSearchBasePath, '_self');
                                }
                            }}

                        >
                            {prop.popupName === 'signUp' || prop.popupName === 'desktop_second_time' ? "Done" : "Search Documents"}
                        </Button>
                    }
                </div>
            </div>
        </div>
    )
}